export const fixDate = (date) => {
    const corrected = (typeof date !== "string" || date.endsWith("Z")) ? date : (date+"Z");
    return new Date(corrected);
}

export const formatDate = (timeStr, includeTime=true) => {
    const time = fixDate(timeStr);
    const day = time.getUTCDate().toString().padStart(2, '0');
    const month = (time.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = time.getUTCFullYear();
    const hours = time.getUTCHours().toString().padStart(2, '0');
    const minutes = time.getUTCMinutes().toString().padStart(2, '0');
    const seconds = time.getUTCSeconds().toString().padStart(2, '0');

    let str = `${year}-${month}-${day}`;
    if(includeTime) str += ` ${hours}:${minutes}:${seconds}`;
    return str;
};

export const getRelativeTime = (dateString, includeSeconds = false, maxTerms=-1) => {
    const date = fixDate(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSecs = Math.floor(Math.abs(diffMs) / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);
    
    const remainingDays = diffDays % 7;
    const remainingHours = diffHours % 24;
    const remainingMins = diffMins % 60;
    const remainingSecs = diffSecs % 60;
    
    const terms = [];
    if (diffWeeks > 0) terms.push(`${diffWeeks}w`);
    if (remainingDays > 0) terms.push(`${remainingDays}d`);
    if (remainingHours > 0) terms.push(`${remainingHours}h`);
    if (remainingMins > 0) terms.push(`${remainingMins}m`);
    if (includeSeconds && remainingSecs > 0) terms.push(`${remainingSecs}s`);
    
    if(!terms.length) return 'just now';
    const termsToUse = maxTerms > 0 ? terms.slice(0, maxTerms) : terms;
    const result = termsToUse.join(" ");
    return diffMs > 0 ? `${result} ago` : `in ${result}`;
};

export const getDayOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date - start;
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    return dayOfYear.toString().padStart(3, '0');
};

// Human-readable gap between two ISO timestamps, e.g. "1h 7m 12s" or "7m 12s".
// Returns null when either bound is missing or the end is not after the start.
export const formatDuration = (startISO, endISO) => {
    if (!startISO || !endISO) return null;
    const ms = new Date(endISO).getTime() - new Date(startISO).getTime();
    if (ms <= 0) return null;
    const totalSec = Math.round(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const parts = [];
    if (h) parts.push(`${h}h`);
    if (h || m) parts.push(`${m}m`);
    parts.push(`${s}s`);
    return parts.join(" ");
};